import api from './api';

export interface ChartConfig {
  type: 'line' | 'bar' | 'pie' | 'doughnut';
  title: string;
  config: {
    labels: string[];
    datasets: any[];
  };
}

export interface Analysis {
  summary: string;
  insights: string[];
  recommendation: string;
}

export interface AIReport {
  query: string;
  analysis: Analysis;
  data: any[];
  charts: ChartConfig[];
  sql_query: string;
  metadata: {
    query_time_ms: number;
    data_points: number;
    charts_generated: number;
    generated_at: string;
  };
}

export interface Suggestion {
  id: string;
  title: string;
  query: string;
  category: string;
}

export const aiReportsService = {
  generate: (query: string, context?: Record<string, any>) =>
    api.post<{ success: boolean; data: AIReport }>('/ai-reports/generate', { query, context }),

  getSuggestions: () =>
    api.get<{ success: boolean; data: Suggestion[] }>('/ai-reports/suggestions'),

  getHistory: () =>
    api.get<{ success: boolean; data: any[] }>('/ai-reports/history'),
};
